import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Loader } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TambahRegisterFidusia = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [alamatSama, setAlamatSama] = useState(false);
  const [cif, setCif] = useState("");
  const [nikCustomer, setNikCustomer] = useState("");
  const [noKkCustomer, setNoKkCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [namaPanggilanCustomer, setNamaPanggilanCustomer] = useState("");
  const [tempatLahirCustomer, setTempatLahirCustomer] = useState("");
  const [tanggalLahirCustomer, setTanggalLahirCustomer] = useState(new Date());
  const [jenisKelaminCustomer, setJenisKelaminCustomer] = useState("");
  const [agamaCustomer, setAgamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [alamatCustomer, setAlamatCustomer] = useState("");
  const [alamatTTCustomer, setAlamatTTCustomer] = useState("");
  const [kodeProvinsi, setKodeProvinsi] = useState("");
  const [ketProvinsi, setKetProvinsi] = useState("");
  const [kodeProvinsiTT, setKodeProvinsiTT] = useState("");
  const [ketProvinsiTT, setKetProvinsiTT] = useState("");
  const [kodeKabupaten, setKodeKabupaten] = useState("");
  const [ketKabupaten, setKetKabupaten] = useState("");
  const [kodeKabupatenTT, setKodeKabupatenTT] = useState("");
  const [ketKabupatenTT, setKetKabupatenTT] = useState("");
  const [kodeKecamatan, setKodeKecamatan] = useState("");
  const [ketKecamatan, setKetKecamatan] = useState("");
  const [kodeKecamatanTT, setKodeKecamatanTT] = useState("");
  const [ketKecamatanTT, setKetKecamatanTT] = useState("");
  const [kodeKelurahan, setKodeKelurahan] = useState("");
  const [ketKelurahan, setKetKelurahan] = useState("");
  const [kodeKelurahanTT, setKodeKelurahanTT] = useState("");
  const [ketKelurahanTT, setKetKelurahanTT] = useState("");
  const [kodePos, setKodePos] = useState("");
  const [kodePosTT, setKodePosTT] = useState("");
  const [statusPerkawinanCustomer, setStatusPerkawinanCustomer] = useState("");
  const [pekerjaanCustomer, setPekerjaanCustomer] = useState("");
  const [kewarganegaraanCustomer, setKewarganegaraanCustomer] = useState("");

  const [namaPerusahaanCustomer, setNamaPerusahaanCustomer] = useState("");
  const [bidangUsahaCustomer, setBidangUsahaCustomer] = useState("");
  const [jabatanCustomer, setJabatanCustomer] = useState("");
  const [alamatPerusahaanCustomer, setAlamatPerusahaanCustomer] = useState("");
  const [noTeleponPerusahaanCustomer, setNoTeleponPerusahaanCustomer] =
    useState("");
  const [lamaKerjaCustomer, setLamaKerjaCustomer] = useState("");
  const [gajiPekerjaanCustomer, setGajiPekerjaanCustomer] = useState("0");
  const [pendapatanLainCustomer, setPendapatanLainCustomer] = useState("0");

  // Data Penjamin
  const [nikPenjamin, setNikPenjamin] = useState("");
  const [noKkPenjamin, setNoKkPenjamin] = useState("");
  const [namaPenjamin, setNamaPenjamin] = useState("");
  const [tempatLahirPenjamin, setTempatLahirPenjamin] = useState("");
  const [tanggalLahirPenjamin, setTanggalLahirPenjamin] = useState(null);
  const [jenisKelaminPenjamin, setJenisKelaminPenjamin] = useState("");
  const [agamaPenjamin, setAgamaPenjamin] = useState("");
  const [noTeleponPenjamin, setNoTeleponPenjamin] = useState("");
  const [alamatPenjamin, setAlamatPenjamin] = useState("");
  const [kodeProvinsiPenjamin, setKodeProvinsiPenjamin] = useState("");
  const [ketProvinsiPenjamin, setKetProvinsiPenjamin] = useState("");
  const [kodeKabupatenPenjamin, setKodeKabupatenPenjamin] = useState("");
  const [ketKabupatenPenjamin, setKetKabupatenPenjamin] = useState("");
  const [kodeKecamatanPenjamin, setKodeKecamatanPenjamin] = useState("");
  const [ketKecamatanPenjamin, setKetKecamatanPenjamin] = useState("");
  const [kodeKelurahanPenjamin, setKodeKelurahanPenjamin] = useState("");
  const [ketKelurahanPenjamin, setKetKelurahanPenjamin] = useState("");
  const [kodePosPenjamin, setKodePosPenjamin] = useState("");
  const [statusPerkawinanPenjamin, setStatusPerkawinanPenjamin] = useState("");
  const [pekerjaanPenjamin, setPekerjaanPenjamin] = useState("");
  const [kewarganegaraanPenjamin, setKewarganegaraanPenjamin] = useState("");
  const [hubunganPenjamin, setHubunganPenjamin] = useState("");

  const [alamatSamaPenjamin, setAlamatSamaPenjamin] = useState(false);
  const [alamatTTPenjamin, setAlamatTTPenjamin] = useState("");
  const [kodeProvinsiTTPenjamin, setKodeProvinsiTTPenjamin] = useState("");
  const [ketProvinsiTTPenjamin, setKetProvinsiTTPenjamin] = useState("");
  const [kodeKabupatenTTPenjamin, setKodeKabupatenTTPenjamin] = useState("");
  const [ketKabupatenTTPenjamin, setKetKabupatenTTPenjamin] = useState("");
  const [kodeKecamatanTTPenjamin, setKodeKecamatanTTPenjamin] = useState("");
  const [ketKecamatanTTPenjamin, setKetKecamatanTTPenjamin] = useState("");
  const [kodeKelurahanTTPenjamin, setKodeKelurahanTTPenjamin] = useState("");
  const [ketKelurahanTTPenjamin, setKetKelurahanTTPenjamin] = useState("");
  const [kodePosTTPenjamin, setKodePosTTPenjamin] = useState("");

  const [uangMuka, setUangMuka] = useState("");
  const [pinjamanAju, setPinjamanAju] = useState("");
  const [angPerBulan, setAngPerBulan] = useState("");
  const [tenor, setTenor] = useState("");
  const [pengajuanKredit, setPengajuanKredit] = useState("");

  const [merk, setMerk] = useState("");
  const [tipe, setTipe] = useState("");
  const [tahun, setTahun] = useState("");
  const [warna, setWarna] = useState("");
  const [nopol, setNopol] = useState("");
  const [keterangan, setKeterangan] = useState("");

  const [kelurahans, setKelurahans] = useState([]);
  const [kecamatans, setKecamatans] = useState([]);
  const [kabupatens, setKabupatens] = useState([]);
  const [provinsis, setProvinsis] = useState([]);
  const [tipes, setTipes] = useState([]);
  const [warnas, setWarnas] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const jenisKelaminOption = ["LAKI-LAKI", "PEREMPUAN"];
  const agamaOption = [
    "ISLAM",
    "PROTESTAN",
    "KATOLIK",
    "HINDU",
    "BUDHA",
    "KHONGHUCU",
    "LAIN",
  ];
  const statusPerkawinanOption = [
    "BELUM MENIKAH",
    "(JANDA/DUDA)",
    "MENIKAH",
    "MENIKAH / ISTRI",
    "MENIKAH / SUAMI",
  ];
  const kewarganegaraanOption = ["WNI", "WNA"];
  let kelurahanOptions = kelurahans.map((kelurahan) => ({
    label: `${kelurahan.id} - ${kelurahan.namaKelurahan}`,
  }));
  let kecamatanOptions = kecamatans.map((kecamatan) => ({
    label: `${kecamatan.id} - ${kecamatan.namaKecamatan}`,
  }));
  let kabupatenOptions = kabupatens.map((kabupaten) => ({
    label: `${kabupaten.id} - ${kabupaten.namaKabupaten}`,
  }));
  let provinsiOptions = provinsis.map((provinsi) => ({
    label: `${provinsi.id} - ${provinsi.namaProvinsi}`,
  }));
  const pengajuanKreditOption = ["KL", "KU", "KU RO LUNAS", "KU RO SISA", "KM"];
  let tipeOptions = tipes.map((tipe) => ({
    label: `${tipe.kodeTipe} | ${tipe.namaTipe}`,
  }));

  useEffect(() => {
    getAreaData();
    getTipesData();
    getWarnasData();
    getCustomerNextKode();
  }, []);

  const getAreaData = async (kodeUnit) => {
    const allKelurahan = await axios.post(`${tempUrl}/kelurahans`, {
      _id: user.id,
      token: user.token,
    });
    setKelurahans(allKelurahan.data);

    const allKecamatan = await axios.post(`${tempUrl}/kecamatans`, {
      _id: user.id,
      token: user.token,
    });
    setKecamatans(allKecamatan.data);

    const allKabupaten = await axios.post(`${tempUrl}/kabupatens`, {
      _id: user.id,
      token: user.token,
    });
    setKabupatens(allKabupaten.data);

    const allProvinsi = await axios.post(`${tempUrl}/provinsis`, {
      _id: user.id,
      token: user.token,
    });
    setProvinsis(allProvinsi.data);

    setJenisKelaminCustomer(jenisKelaminOption[0]);
    setAgamaCustomer(agamaOption[0]);
    setStatusPerkawinanCustomer(statusPerkawinanOption[0]);
    setKewarganegaraanCustomer(kewarganegaraanOption[0]);
    setPengajuanKredit(pengajuanKreditOption[0]);

    setJenisKelaminPenjamin(jenisKelaminOption[0]);
    setAgamaPenjamin(agamaOption[0]);
    setStatusPerkawinanPenjamin(statusPerkawinanOption[0]);
    setKewarganegaraanPenjamin(kewarganegaraanOption[0]);
  };

  const getTipesData = async () => {
    const response = await axios.post(`${tempUrl}/tipes`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setTipes(response.data);
  };

  const getWarnasData = async () => {
    setWarna("");
    const response = await axios.post(`${tempUrl}/warnas`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setWarnas(response.data);
    setWarna(response.data[0].namaWarna);
  };

  const findKelurahan = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahan(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan("");
        setKodePos("");
        setKodeKelurahan(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePos(response.data.kodePos);
        setKodeKelurahan(kelurahanId);
      }
    }
  };

  const findKelurahanPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin("");
        setKodePosPenjamin("");
        setKodeKelurahanPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosPenjamin(response.data.kodePos);
        setKodeKelurahanPenjamin(kelurahanId);
      }
    }
  };

  const findKelurahanTT = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTT(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTT(kodePos);
        } else {
          setKodePosTT("");
        }
        setKodeKelurahanTT(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTT(response.data.kodePos);
        setKodeKelurahanTT(kelurahanId);
      }
    }
  };

  const findKelurahanTTPenjamin = async (kelurahanId) => {
    if (kelurahanId) {
      const response = await axios.post(
        `${tempUrl}/kelurahans/${kelurahanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKelurahanTTPenjamin(kelurahanId);
      if (kelurahanId == "99999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin("");
        if (alamatSama && kodePos.length > 0) {
          setKodePosTTPenjamin(kodePos);
        } else {
          setKodePosTTPenjamin("");
        }
        setKodeKelurahanTTPenjamin(kelurahanId);
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.kecamatan.id} - ${response.data.kecamatan.namaKecamatan}`
        );
        setKodePosTTPenjamin(response.data.kodePos);
        setKodeKelurahanTTPenjamin(kelurahanId);
      }
    }
  };

  const findKecamatan = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsi("");
        setKodeKabupaten("");
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatan(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatan(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin("");
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTT = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTT(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT("");
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTT(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKecamatanTTPenjamin = async (kecamatanId) => {
    kecamatanId = kecamatanId.split(" ", 1)[0];
    if (kecamatanId) {
      const response = await axios.post(
        `${tempUrl}/kecamatans/${kecamatanId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKecamatanTTPenjamin(kecamatanId);
      if (kecamatanId == "999999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin("");
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.kabupaten.id} - ${response.data.kabupaten.namaKabupaten}`
        );
        setKodeKecamatanTTPenjamin(
          `${response.data.id} - ${response.data.namaKecamatan}`
        );
      }
    }
  };

  const findKabupaten = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupaten(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsi("");
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsi(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupaten(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiPenjamin("");
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTT = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTT(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTT("");
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTT(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findKabupatenTTPenjamin = async (kabupatenId) => {
    kabupatenId = kabupatenId.split(" ", 1)[0];
    if (kabupatenId) {
      const response = await axios.post(
        `${tempUrl}/kabupatens/${kabupatenId}`,
        {
          _id: user.id,
          token: user.token,
        }
      );
      // setKodeKabupatenTTPenjamin(kabupatenId);
      if (kabupatenId == "9999") {
        setKodeProvinsiTTPenjamin("");
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
        return;
      }
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.provinsis.id} - ${response.data.provinsis.namaProvinsi}`
        );
        setKodeKabupatenTTPenjamin(
          `${response.data.id} - ${response.data.namaKabupaten}`
        );
      }
    }
  };

  const findProvinsi = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsi(provinsiId);
      if (response.data) {
        setKodeProvinsi(`${response.data.id} - ${response.data.namaProvinsi}`);
      }
    }
  };

  const findProvinsiPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTT = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTT(provinsiId);
      if (response.data) {
        setKodeProvinsiTT(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const findProvinsiTTPenjamin = async (provinsiId) => {
    provinsiId = provinsiId.split(" ", 1)[0];
    if (provinsiId) {
      const response = await axios.post(`${tempUrl}/provinsis/${provinsiId}`, {
        _id: user.id,
        token: user.token,
      });
      // setKodeProvinsiTTPenjamin(provinsiId);
      if (response.data) {
        setKodeProvinsiTTPenjamin(
          `${response.data.id} - ${response.data.namaProvinsi}`
        );
      }
    }
  };

  const getCustomerNextKode = async () => {
    const response = await axios.post(`${tempUrl}/customerNextKode`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCif(response.data);
  };

  const findTipe = async (id) => {
    id = id.split(" |", 1)[0];
    if (id) {
      const response = await axios.post(`${tempUrl}/tipeByKodeTipe`, {
        kodeTipe: id,
        _id: user.id,
        token: user.token,
      });
      setTipe(id);
      setMerk(response.data.merk);
    }
  };

  const saveRegisterFidusia = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeKelurahan.length !== 0 &&
      kodeKelurahanTT.length !== 0
    ) {
      setLoading(true);
      try {
        setLoading(true);
        await axios.post(`${tempUrl}/saveRegisterFidusia`, {
          marketingId: user.marketingId,

          nikCustomer,
          noKkCustomer,
          namaCustomer,
          namaPanggilanCustomer,
          tempatLahirCustomer,
          tanggalLahirCustomer,
          jenisKelaminCustomer,
          agamaCustomer,
          noTeleponCustomer,
          alamatCustomer,
          alamatTTCustomer,
          statusPerkawinanCustomer,
          pekerjaanCustomer,
          kewarganegaraanCustomer,

          kelurahanId: kodeKelurahan,
          provinsiId: kodeProvinsi.split(" ", 1)[0],
          kabupatenId: kodeKabupaten.split(" ", 1)[0],
          kecamatanId: kodeKecamatan.split(" ", 1)[0],

          ketProvinsi,
          ketKabupaten,
          ketKecamatan,
          ketKelurahan,
          kodePos,

          kelurahanTTId: kodeKelurahanTT.split(" ", 1)[0],
          provinsiTTId: kodeProvinsiTT.split(" ", 1)[0],
          kabupatenTTId: kodeKabupatenTT.split(" ", 1)[0],
          kecamatanTTId: kodeKecamatanTT.split(" ", 1)[0],

          ketProvinsiTT,
          ketKabupatenTT,
          ketKecamatanTT,
          ketKelurahanTT,
          kodePosTT,

          namaPerusahaanCustomer,
          bidangUsahaCustomer,
          jabatanCustomer,
          alamatPerusahaanCustomer,
          noTeleponPerusahaanCustomer,
          lamaKerjaCustomer,
          gajiPekerjaanCustomer,
          pendapatanLainCustomer,

          // Data Penjamin
          nikPenjamin,
          noKkPenjamin,
          namaPenjamin,
          tempatLahirPenjamin,
          tanggalLahirPenjamin,
          jenisKelaminPenjamin,
          agamaPenjamin,
          noTeleponPenjamin,
          alamatPenjamin,
          statusPerkawinanPenjamin,
          pekerjaanPenjamin,
          kewarganegaraanPenjamin,
          hubunganPenjamin,

          kelurahanIdPenjamin: kodeKelurahanPenjamin.split(" ", 1)[0],
          provinsiIdPenjamin: kodeProvinsiPenjamin.split(" ", 1)[0],
          kabupatenIdPenjamin: kodeKabupatenPenjamin.split(" ", 1)[0],
          kecamatanIdPenjamin: kodeKecamatanPenjamin.split(" ", 1)[0],

          ketProvinsiPenjamin,
          ketKabupatenPenjamin,
          ketKecamatanPenjamin,
          ketKelurahanPenjamin,
          kodePosPenjamin,

          alamatTTPenjamin,
          kelurahanTTIdPenjamin: kodeKelurahanTTPenjamin.split(" ", 1)[0],
          provinsiTTIdPenjamin: kodeProvinsiTTPenjamin.split(" ", 1)[0],
          kabupatenTTIdPenjamin: kodeKabupatenTTPenjamin.split(" ", 1)[0],
          kecamatanTTIdPenjamin: kodeKecamatanTTPenjamin.split(" ", 1)[0],

          ketProvinsiTTPenjamin,
          ketKabupatenTTPenjamin,
          ketKecamatanTTPenjamin,
          ketKelurahanTTPenjamin,
          kodePosTTPenjamin,

          uangMuka,
          pinjamanAju,
          angPerBulan,
          tenor,
          pengajuanKredit,

          merk,
          tipe,
          tahun,
          warna,
          nopol,
          keterangan,

          kodeCabang: user.cabang.id,
          userIdInput: user.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate("/registerFidusia");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Fidusia</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Register Fidusia</h5>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveRegisterFidusia}>
        {/* Customer */}
        <Card>
          <Card.Header>Customer</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        CIF :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control required value={cif} disabled readOnly />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={nikCustomer}
                          onChange={(e) => setNikCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noKkCustomer}
                          onChange={(e) => setNoKkCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          required
                          value={namaCustomer}
                          onChange={(e) => setNamaCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Panggilan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPanggilanCustomer}
                          onChange={(e) =>
                            setNamaPanggilanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={tempatLahirCustomer}
                          onChange={(e) =>
                            setTempatLahirCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirCustomer}
                          onChange={(date) => setTanggalLahirCustomer(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={jenisKelaminCustomer}
                          onChange={(e) => {
                            setJenisKelaminCustomer(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={agamaCustomer}
                          onChange={(e) => {
                            setAgamaCustomer(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noTeleponCustomer}
                          onChange={(e) => setNoTeleponCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={statusPerkawinanCustomer}
                          onChange={(e) => {
                            setStatusPerkawinanCustomer(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={pekerjaanCustomer}
                          onChange={(e) =>
                            setPekerjaanCustomer(e.target.value)} style={{ textTransform: 'uppercase' }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row> */}
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={kewarganegaraanCustomer}
                          onChange={(e) => {
                            setKewarganegaraanCustomer(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas)</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          required
                          value={alamatCustomer}
                          onChange={(e) => setAlamatCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKelurahan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahan(value.label.split(" ", 1)[0]);
                            } else {
                              findKelurahan("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKelurahan !== "99999999"}
                          value={ketKelurahan}
                          onChange={(e) => setKetKelurahan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKecamatan.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatan(value.label);
                            } else {
                              findKecamatan("");
                            }
                          }}
                          value={kodeKecamatan}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKecamatan.split(" ", 1)[0] !== "999999"}
                          value={ketKecamatan}
                          onChange={(e) => setKetKecamatan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error && kodeKabupaten.length === 0 && true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupaten(value.label);
                            } else {
                              findKabupaten("");
                            }
                          }}
                          value={kodeKabupaten}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeKabupaten.split(" ", 1)[0] !== "9999"}
                          value={ketKabupaten}
                          onChange={(e) => setKetKabupaten(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeProvinsi.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsi(value.label);
                            } else {
                              findProvinsi("");
                            }
                          }}
                          value={kodeProvinsi}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          disabled={kodeProvinsi.split(" ", 1)[0] !== "99"}
                          value={ketProvinsi}
                          onChange={(e) => setKetProvinsi(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          type="number"
                          value={kodePos}
                          disabled={
                            kodeKelurahan.split(" ", 1)[0] !== "99999999"
                          }
                          onChange={(e) => setKodePos(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSama}
                          onChange={() => {
                            setAlamatSama(!alamatSama);
                            if (!alamatSama === true) {
                              setAlamatTTCustomer(alamatCustomer);
                              setKodeKelurahanTT(kodeKelurahan);
                              setKetKelurahanTT(ketKelurahan);
                              setKodeKecamatanTT(kodeKecamatan);
                              setKetKecamatanTT(ketKecamatan);
                              setKodeKabupatenTT(kodeKabupaten);
                              setKetKabupatenTT(ketKabupaten);
                              setKodeProvinsiTT(kodeProvinsi);
                              setKetProvinsiTT(ketProvinsi);
                              setKodePosTT(kodePos);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              required
                              value={alamatTTCustomer}
                              onChange={(e) =>
                                setAlamatTTCustomer(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKelurahanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTT(value.label.split(" ", 1)[0]);
                                } else {
                                  findKelurahanTT("");
                                }
                              }}
                              value={kodeKelurahanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              value={ketKelurahanTT}
                              onChange={(e) =>
                                setKetKelurahanTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKecamatanTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTT(value.label);
                                } else {
                                  findKecamatanTT("");
                                }
                              }}
                              value={kodeKecamatanTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKecamatanTT.split(" ", 1)[0] !== "999999"
                              }
                              value={ketKecamatanTT}
                              onChange={(e) =>
                                setKetKecamatanTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error &&
                                    kodeKabupatenTT.length === 0 &&
                                    true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTT(value.label);
                                } else {
                                  findKabupatenTT("");
                                }
                              }}
                              value={kodeKabupatenTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeKabupatenTT.split(" ", 1)[0] !== "9999"
                              }
                              value={ketKabupatenTT}
                              onChange={(e) =>
                                setKetKabupatenTT(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField
                                  error={
                                    error && kodeProvinsiTT.length === 0 && true
                                  }
                                  size="small"
                                  {...params}
                                />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTT(value.label);
                                } else {
                                  findProvinsiTT("");
                                }
                              }}
                              value={kodeProvinsiTT}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              disabled={
                                kodeProvinsiTT.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTT}
                              onChange={(e) => setKetProvinsiTT(e.target.value)}
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS <b style={colorRed}>*</b> :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              required
                              type="number"
                              value={kodePosTT}
                              disabled={
                                kodeKelurahanTT.split(" ", 1)[0] !== "99999999"
                              }
                              onChange={(e) => setKodePosTT(e.target.value)}
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Pekerjaan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pekerjaan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaPerusahaanCustomer}
                          onChange={(e) =>
                            setNamaPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bidang Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={bidangUsahaCustomer}
                          onChange={(e) =>
                            setBidangUsahaCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jabatan / Posisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jabatanCustomer}
                          onChange={(e) => setJabatanCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat Perusahaan / Usaha <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={alamatPerusahaanCustomer}
                          onChange={(e) =>
                            setAlamatPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No .Telp Perusahaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noTeleponPerusahaanCustomer}
                          onChange={(e) =>
                            setNoTeleponPerusahaanCustomer(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kerja / Status <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={lamaKerjaCustomer}
                          onChange={(e) => setLamaKerjaCustomer(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Besaran Gaji / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={gajiPekerjaanCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setGajiPekerjaanCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pendapatan Lain :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={pendapatanLainCustomer}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPendapatanLainCustomer(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        NIK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={nikPenjamin}
                          onChange={(e) => setNikPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. KK :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={noKkPenjamin}
                          onChange={(e) => setNoKkPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={namaPenjamin}
                          onChange={(e) => setNamaPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tempat Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={tempatLahirPenjamin}
                          onChange={(e) =>
                            setTempatLahirPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Lahir :
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          customInput={<Form.Control />}
                          selected={tanggalLahirPenjamin}
                          onChange={(date) => setTanggalLahirPenjamin(date)}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Kelamin :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={jenisKelaminPenjamin}
                          onChange={(e) => {
                            setJenisKelaminPenjamin(e.target.value);
                          }}
                        >
                          {jenisKelaminOption.map((jenisKelamin) => (
                            <option value={jenisKelamin}>{jenisKelamin}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Agama :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={agamaPenjamin}
                          onChange={(e) => {
                            setAgamaPenjamin(e.target.value);
                          }}
                        >
                          {agamaOption.map((agama) => (
                            <option value={agama}>{agama}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Telp / HP :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          type="number"
                          value={noTeleponPenjamin}
                          onChange={(e) => setNoTeleponPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Status Perkawinan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={statusPerkawinanPenjamin}
                          onChange={(e) => {
                            setStatusPerkawinanPenjamin(e.target.value);
                          }}
                        >
                          {statusPerkawinanOption.map((statusPerkawinan) => (
                            <option value={statusPerkawinan}>
                              {statusPerkawinan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pekerjaan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={pekerjaanPenjamin}
                          onChange={(e) => setPekerjaanPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kewarganegaraan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          value={kewarganegaraanPenjamin}
                          onChange={(e) => {
                            setKewarganegaraanPenjamin(e.target.value);
                          }}
                        >
                          {kewarganegaraanOption.map((kewarganegaraan) => (
                            <option value={kewarganegaraan}>
                              {kewarganegaraan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Hubungan dengan nasabah :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          value={hubunganPenjamin}
                          onChange={(e) => setHubunganPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Alamat (Identitas) Penjamin */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Alamat (Identitas) Penjamin</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Alamat :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={alamatPenjamin}
                          onChange={(e) => setAlamatPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kel. / Desa :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kelurahanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKelurahanPenjamin(
                                value.label.split(" ", 1)[0]
                              );
                            } else {
                              findKelurahanPenjamin("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={kodeKelurahanPenjamin !== "99999999"}
                          value={ketKelurahanPenjamin}
                          onChange={(e) =>
                            setKetKelurahanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kecamatan :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kecamatanOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKecamatanPenjamin(value.label);
                            } else {
                              findKecamatanPenjamin("");
                            }
                          }}
                          value={kodeKecamatanPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKecamatanPenjamin.split(" ", 1)[0] !== "999999"
                          }
                          value={ketKecamatanPenjamin}
                          onChange={(e) =>
                            setKetKecamatanPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kabupaten / Kota :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={kabupatenOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findKabupatenPenjamin(value.label);
                            } else {
                              findKabupatenPenjamin("");
                            }
                          }}
                          value={kodeKabupatenPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeKabupatenPenjamin.split(" ", 1)[0] !== "9999"
                          }
                          value={ketKabupatenPenjamin}
                          onChange={(e) =>
                            setKetKabupatenPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Provinsi :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={provinsiOptions}
                          renderInput={(params) => (
                            <TextField size="small" {...params} />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findProvinsiPenjamin(value.label);
                            } else {
                              findProvinsiPenjamin("");
                            }
                          }}
                          value={kodeProvinsiPenjamin}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}></Form.Label>
                      <Col sm="7">
                        <Form.Control
                          disabled={
                            kodeProvinsiPenjamin.split(" ", 1)[0] !== "99"
                          }
                          value={ketProvinsiPenjamin}
                          onChange={(e) =>
                            setKetProvinsiPenjamin(e.target.value)
                          }
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode POS :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          type="number"
                          value={kodePosPenjamin}
                          disabled={
                            kodeKelurahanPenjamin.split(" ", 1)[0] !==
                            "99999999"
                          }
                          onChange={(e) => setKodePosPenjamin(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Tempat Tinggal */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Tempat Tinggal</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Card style={{ marginTop: "10px" }}>
                  <Card.Header>
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Box></Box>
                      <Box>
                        <Form.Check
                          type="checkbox"
                          label="Sama dengan alamat identitas"
                          checked={alamatSamaPenjamin}
                          onChange={() => {
                            setAlamatSamaPenjamin(!alamatSamaPenjamin);
                            if (!alamatSamaPenjamin === true) {
                              setAlamatTTPenjamin(alamatPenjamin);
                              setKodeKelurahanTTPenjamin(kodeKelurahanPenjamin);
                              setKetKelurahanTTPenjamin(ketKelurahanPenjamin);
                              setKodeKecamatanTTPenjamin(kodeKecamatanPenjamin);
                              setKetKecamatanTTPenjamin(ketKecamatanPenjamin);
                              setKodeKabupatenTTPenjamin(kodeKabupatenPenjamin);
                              setKetKabupatenTTPenjamin(ketKabupatenPenjamin);
                              setKodeProvinsiTTPenjamin(kodeProvinsiPenjamin);
                              setKetProvinsiTTPenjamin(ketProvinsiPenjamin);
                              setKodePosTTPenjamin(kodePosPenjamin);
                            }
                          }}
                        />
                      </Box>
                    </Box>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Alamat :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={alamatTTPenjamin}
                              onChange={(e) =>
                                setAlamatTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kel. / Desa :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kelurahanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKelurahanTTPenjamin(
                                    value.label.split(" ", 1)[0]
                                  );
                                } else {
                                  findKelurahanTTPenjamin("");
                                }
                              }}
                              value={kodeKelurahanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              value={ketKelurahanTTPenjamin}
                              onChange={(e) =>
                                setKetKelurahanTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kecamatan :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kecamatanOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKecamatanTTPenjamin(value.label);
                                } else {
                                  findKecamatanTTPenjamin("");
                                }
                              }}
                              value={kodeKecamatanTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKecamatanTTPenjamin.split(" ", 1)[0] !==
                                "999999"
                              }
                              value={ketKecamatanTTPenjamin}
                              onChange={(e) =>
                                setKetKecamatanTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kabupaten / Kota :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={kabupatenOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findKabupatenTTPenjamin(value.label);
                                } else {
                                  findKabupatenTTPenjamin("");
                                }
                              }}
                              value={kodeKabupatenTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeKabupatenTTPenjamin.split(" ", 1)[0] !==
                                "9999"
                              }
                              value={ketKabupatenTTPenjamin}
                              onChange={(e) =>
                                setKetKabupatenTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Provinsi :
                          </Form.Label>
                          <Col sm="7">
                            <Autocomplete
                              size="small"
                              disablePortal
                              id="combo-box-demo"
                              options={provinsiOptions}
                              renderInput={(params) => (
                                <TextField size="small" {...params} />
                              )}
                              onChange={(e, value) => {
                                if (value) {
                                  findProvinsiTTPenjamin(value.label);
                                } else {
                                  findProvinsiTTPenjamin("");
                                }
                              }}
                              value={kodeProvinsiTTPenjamin}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label
                            column
                            sm="5"
                            style={textRight}
                          ></Form.Label>
                          <Col sm="7">
                            <Form.Control
                              disabled={
                                kodeProvinsiTTPenjamin.split(" ", 1)[0] !== "99"
                              }
                              value={ketProvinsiTTPenjamin}
                              onChange={(e) =>
                                setKetProvinsiTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Kode POS :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              type="number"
                              value={kodePosTTPenjamin}
                              disabled={
                                kodeKelurahanTTPenjamin.split(" ", 1)[0] !==
                                "99999999"
                              }
                              onChange={(e) =>
                                setKodePosTTPenjamin(e.target.value)
                              }
                              style={{ textTransform: "uppercase" }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Pinjaman */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Pinjaman</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Uang Muka <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={uangMuka}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setUangMuka(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pinjaman Rp <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={pinjamanAju}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setPinjamanAju(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Ansuran / Bulan <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={angPerBulan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setAngPerBulan(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tenor <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={tenor}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            setTenor(
                              values.formattedValue
                                .split(".")
                                .join("")
                                .replace(/,/g, "")
                            );
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Pengajuan kredit <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={pengajuanKredit}
                          onChange={(e) => {
                            setPengajuanKredit(e.target.value);
                          }}
                        >
                          {pengajuanKreditOption.map((value) => (
                            <option value={value}>{value}</option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Data Kendaraan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Data Kendaraan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Merk <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={merk}
                          onChange={(e) => setMerk(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={tipeOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && tipe.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              findTipe(value.label);
                            } else {
                              findTipe("");
                            }
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tahun <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={tahun}
                          onChange={(e) => setTahun(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Warna <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={warna}
                          onChange={(e) => {
                            setWarna(e.target.value);
                          }}
                        >
                          {warnas.map((warna, index) => (
                            <option value={warna.namaWarna}>
                              {warna.namaWarna}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={nopol}
                          onChange={(e) => setNopol(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        {/* Keterangan */}
        <Card style={{ marginTop: "20px" }}>
          <Card.Header>Keterangan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Keterangan :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          as="textarea"
                          rows={4}
                          value={keterangan}
                          onChange={(e) => setKeterangan(e.target.value)}
                          style={{ textTransform: "uppercase" }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/registerFidusia")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default TambahRegisterFidusia;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const colorRed = {
  color: "red",
};
